module.exports = __webpack_public_path__ + "static/spokoj_iphone-ead9a9b0c9df467d26b465f03b5a7a36.png";